import { connect, MapStateToProps } from 'react-redux'
import { Props } from './LastConfigurations'
import {
    fetchLastConfigurationsInfo,
    fetchLastConfigurationsForDate,
} from '../../redux/actions/app/lastConfigurations.actions'
import lastConfigurationsInfoSelector
    from '../../redux/selectors/garage/lastConfigurationsInfoSelector'
import lastConfigurationsRequestIsPendingSelector
    from '../../redux/selectors/pending-request/lastConfigurationsRequestIsPendingSelector'
import { loadConfigurationByVehicleCode } from '../../redux/actions/app/vehicleCode.actions'

type StateProps = Pick<Props, 'lastConfigurationsInfo' | 'isLoading'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    lastConfigurationsInfo: lastConfigurationsInfoSelector(state),
    isLoading: lastConfigurationsRequestIsPendingSelector(state),
})

type DispatchProps = Pick<Props, 'loadLastConfigurationsInfo' | 'loadLastConfigurationsForDate' | 'loadConfigurationByVehicleCode'>

const mapDispatchToProps: DispatchProps = {
    loadLastConfigurationsInfo: fetchLastConfigurationsInfo,
    loadLastConfigurationsForDate: fetchLastConfigurationsForDate,
    loadConfigurationByVehicleCode: loadConfigurationByVehicleCode,
}

export default connect(mapStateToProps, mapDispatchToProps)
